/**
 * Vant 内置文案（选择器“取消/确认”、加载提示等）跟随项目语言切换。
 * Vant 只内置了部分语言，其余语言以英文为底，覆盖常用按钮文案。
 */
import { Locale } from 'vant';
import enUS from 'vant/lib/locale/lang/en-US';
import esES from 'vant/lib/locale/lang/es-ES';
import frFR from 'vant/lib/locale/lang/fr-FR';
import deDE from 'vant/lib/locale/lang/de-DE';
import zhCN from 'vant/lib/locale/lang/zh-CN';

function withOverrides(base, messages) {
  return Object.assign({}, base, messages);
}

const LOCALES = {
  en_us: ['en-US', enUS],
  es_spa: ['es-ES', esES],
  fr: ['fr-FR', frFR],
  de: ['de-DE', deDE],
  it: ['it-IT', withOverrides(enUS, { confirm: 'Conferma', cancel: 'Annulla' })],
  nl: ['nl-NL', withOverrides(enUS, { confirm: 'Bevestigen', cancel: 'Annuleren' })],
  pt: ['pt-PT', withOverrides(enUS, { confirm: 'Confirmar', cancel: 'Cancelar' })],
  pl: ['pl-PL', withOverrides(enUS, { confirm: 'Potwierdź', cancel: 'Anuluj' })],
  zh_cn: ['zh-CN', zhCN]
};

export function applyVantLocale(lang) {
  const locale = LOCALES[lang] || LOCALES.en_us;
  Locale.use(locale[0], locale[1]);
}

export default applyVantLocale;
